import { render } from "./App.vue?vue&type=template&id=9996ec6c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9996ec6c&lang=less"

import exportComponent from "D:\\Data_code\\Vue\\196116_com_4000_ver2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__